import {
    apiRequest,
    skpnsUpdate,
    skpnsDetail,
    masterRank,
    masterSignatoryOfficial,
    masterDocumentType
} from "../../../../../services/adapters/kepegawaian/skpnsService"

class UpdateRepository {

    fetchUpdate = async (query) => {
        return await apiRequest("post", skpnsUpdate, {
            body: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", skpnsDetail, {
            params: query
        }, true)
    }

    fetchRank = async (query) => {
        return await apiRequest("get", masterRank, {
            params: query
        }, true)
    }

    fetchSignatoryOfficial = async (query) => {
        return await apiRequest("get", masterSignatoryOfficial, {
            params: query
        }, true)
    }

    fetchDocumentType = async (query) => {
        return await apiRequest("get", masterDocumentType, {
            params: query
        }, true)
    }

}

export default UpdateRepository